module.exports = __webpack_public_path__ + "static/media/Bars.8c770ba0.png";